import { Select } from '@servicecompressionllc/sc-design-system';
import { TemplateInput } from '../controls/TemplateInput.js';
import type { ForkStepEditorProps } from './types.js';

export const ApprovalStepEditor = ({
  step,
  path,
  ctx,
  vars,
  Arm,
  onChange: put,
}: ForkStepEditorProps<'approval'>) => {
  return (
    <>
      <TemplateInput
        label="What to ask them"
        value={step.title}
        vars={vars}
        source={ctx.eventSource}
        onChange={(v) => put({ ...step, title: v })}
      />
      <label className="grid gap-1 text-xs text-ink-muted">
        Who can approve
        <Select
          aria-label="Approvers"
          multiple
          options={ctx.approverCandidates.map((c) => ({
            value: `${c.kind}:${c.id}`,
            label: c.label,
          }))}
          value={step.approvers.map((a) => `${a.kind}:${a.id}`)}
          onChange={(v) =>
            put({
              ...step,
              approvers: v.map((s) => {
                const [kind, id] = s.split(':');
                return { kind: kind as 'user' | 'group', id: id ?? '' };
              }),
            })
          }
        />
      </label>
      <Arm
        label="Approved"
        emptyText="Nothing happens yet when they approve — add what should."
        steps={step.onApprove}
        containerPath={[...path, 'onApprove']}
        ctx={ctx}
      />
      <Arm
        label="Declined"
        emptyText="Nothing happens yet when they decline — add what should."
        steps={step.onDecline}
        containerPath={[...path, 'onDecline']}
        ctx={ctx}
      />
    </>
  );
};
